// 南勝版ダウンロードフォームページ（キーエンススタイル）
import { reports } from '../data/whitepapers.js';
import { FORM_MESSAGES, getAvailableCount } from '../config/whitepaper-availability.js';
import { isWhitepaperAvailable } from '../utils/filter-available-whitepapers.js';
import { collection, addDoc, serverTimestamp, query, where, getDocs, orderBy, limit, doc, getDoc } from 'firebase/firestore';
import { db } from '../main.js';
import { showUnsubscribeModal, showPurchaserModal } from '../components/unsubscribe-modal.js';

export function DownloadFormPage(params) {
  const whitepaperId = params.whitepaperId;

  // 公開判定ガード
  // 未公開IDに直リンクで到達した場合、フォームを描画せず案内だけを返す。
  // メルマガで未公開レポートの直リンクを案内した際に、フォーム通過後のPDFが404になり
  // Firestoreへ無駄な申込レコードが残った事故の再発防止（submitFormまで到達させない）。
  if (!isWhitepaperAvailable(whitepaperId)) {
    return `
    <div class="download-page">
      <!-- ヘッダー -->
      <header class="download-header">
        <div class="header-inner">
          <h1 class="logo">
            <a href="/">
              <img src="/images/logo.svg" alt="反響成約マスター" />
            </a>
          </h1>
        </div>
      </header>

      <div class="download-main">
        <h1 class="page-title">このレポートは準備中です</h1>

        <div class="download-content">
          <div class="whitepaper-info">
            <div class="whitepaper-details">
              <p class="whitepaper-meta">
                お探しのレポートは現在準備中のため、ダウンロードいただけません。<br />
                公開中の${getAvailableCount()}本のレポートは、下記の一覧からご覧いただけます。
              </p>
              <p>
                <a href="/master/download">公開中のレポート一覧を見る</a>
              </p>
            </div>
          </div>
        </div>
      </div>

      <footer class="download-footer">
        <div class="footer-inner">
          <div class="footer-logo">反響成約マスター</div>
          <nav class="footer-nav">
            <a href="/privacy.html">個人情報の取り扱いについて</a>
            <a href="/company.html">会社概要</a>
            <a href="/master/contact">お問い合わせ</a>
          </nav>
          <p class="footer-company">運営：株式会社南勝</p>
          <p class="copyright">Copyright © 2025 株式会社南勝. All Rights Reserved.</p>
        </div>
      </footer>
    </div>
  `;
  }

  // ホワイトペーパー情報をreportsから取得
  const whitepapers = reports;
  
  const wp = whitepapers[whitepaperId] || whitepapers.wp01;
  
  // デバッグ用にホワイトペーパーIDと画像パスを出力
  
  // グローバル関数の定義
  // showStep関数を先に定義
  window.showStep = function(step) {
    document.querySelectorAll('.form-step').forEach(el => {
      el.classList.toggle('active', parseInt(el.dataset.step) === step);
    });

    // プログレスバーの更新
    const progressBar = document.querySelector('.progress-bar');
    const totalSteps = 2;
    const displayStep = step > 2 ? 2 : step;
    progressBar.style.width = `${(displayStep / totalSteps) * 100}%`;

    // ステップ表示の更新
    document.querySelector('.step-indicator').textContent = `ステップ ${displayStep}/${totalSteps}`;
  };

  window.nextStep = async function() {
    const form = document.getElementById('step-form');
    const currentStepEl = document.querySelector('.form-step.active');
    const inputs = currentStepEl.querySelectorAll('input[required], select[required]');

    // バリデーション
    let isValid = true;
    inputs.forEach(input => {
      if (!input.value.trim()) {
        input.classList.add('error');
        isValid = false;
      } else {
        input.classList.remove('error');
      }
    });

    if (!isValid) return;

    const currentStep = parseInt(currentStepEl.dataset.step);

    // ステップ1（メール入力）の場合、既存会員チェック
    if (currentStep === 1) {
      const emailInput = form.querySelector('input[name="email"]');
      const email = emailInput.value.toLowerCase();


      try {
        // Phase 1: 配信停止・購入者チェックを先に実行
        // importは既に上部で完了しているので、直接使用

        // 配信停止チェック（正しいコレクション名：unsubscribes）
        const unsubscribedRef = doc(db, 'unsubscribes', email);
        const unsubscribedDoc = await getDoc(unsubscribedRef);

        if (unsubscribedDoc.exists() && unsubscribedDoc.data().active !== false) {
          // 配信停止済みの場合、エラーメッセージを表示

          // モーダルで通知
          showUnsubscribeModal(email);

          // フォームをリセット
          const emailInput = form.querySelector('input[name="email"]');
          if (emailInput) {
            emailInput.value = '';
            emailInput.focus();
          }

          return; // ここで処理を終了
        }

        // 購入者チェック
        const purchaserRef = doc(db, 'purchasers', email);
        const purchaserDoc = await getDoc(purchaserRef);

        if (purchaserDoc.exists()) {
          // 購入者の場合、モーダルを表示
          showPurchaserModal(email);

          // フォームをリセット
          const emailInput = form.querySelector('input[name="email"]');
          if (emailInput) {
            emailInput.value = '';
            emailInput.focus();
          }

          return; // ここで処理を終了
        }

        // チェックが通った場合のみ、既存会員チェックを実行
        // downloadsコレクションから既存データを検索
        const downloadsRef = collection(db, 'downloads');

        // まず単純なクエリでテスト（orderByなし）
        const simpleQuery = query(
          downloadsRef,
          where('email', '==', email),
          limit(1)
        );

        const querySnapshot = await getDocs(simpleQuery);

        if (!querySnapshot.empty) {
          const memberData = querySnapshot.docs[0].data();

          // 既存会員の場合、フォームにデータを設定してから直接送信
          const emailInput = form.querySelector('input[name="email"]');
          if (emailInput) emailInput.value = email;

          // フォームにデータを自動入力（非表示フィールドも含む）
          if (memberData.name) {
            const names = memberData.name.split(' ');
            const lastNameInput = form.querySelector('input[name="lastName"]');
            const firstNameInput = form.querySelector('input[name="firstName"]');
            if (!lastNameInput) {
              // 隠しフィールドを作成
              const hiddenLastName = document.createElement('input');
              hiddenLastName.type = 'hidden';
              hiddenLastName.name = 'lastName';
              hiddenLastName.value = names[0] || '';
              form.appendChild(hiddenLastName);

              const hiddenFirstName = document.createElement('input');
              hiddenFirstName.type = 'hidden';
              hiddenFirstName.name = 'firstName';
              hiddenFirstName.value = names[1] || '';
              form.appendChild(hiddenFirstName);
            } else {
              lastNameInput.value = names[0] || '';
              firstNameInput.value = names[1] || '';
            }
          }

          // その他のフィールドも隠しフィールドとして追加
          ['company'].forEach(field => {
            let input = form.querySelector(`input[name="${field}"]`);
            if (!input) {
              // 隠しフィールドを作成
              input = document.createElement('input');
              input.type = 'hidden';
              input.name = field;
              form.appendChild(input);
            }
            if (memberData[field]) {
              input.value = memberData[field];
            } else {
              input.value = '';
            }
          });

          // 洗練されたローディング表示を作成
          const loadingOverlay = document.createElement('div');
          loadingOverlay.className = 'member-loading-overlay';
          loadingOverlay.innerHTML = `
            <div class="member-loading-card">
              <div class="loading-spinner"></div>
              <h3>会員情報を確認しました</h3>
              <p>${memberData.name} 様</p>
              <p class="loading-message">レポートを準備しています...</p>
            </div>
          `;
          document.body.appendChild(loadingOverlay);

          // スタイルを動的に追加
          if (!document.querySelector('#member-loading-styles')) {
            const styles = document.createElement('style');
            styles.id = 'member-loading-styles';
            styles.textContent = `
              .member-loading-overlay {
                position: fixed;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                background: rgba(0, 0, 0, 0.7);
                display: flex;
                align-items: center;
                justify-content: center;
                z-index: 10000;
                animation: fadeIn 0.3s ease-in;
              }

              .member-loading-card {
                background: white;
                padding: 40px;
                border-radius: 12px;
                text-align: center;
                box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
                max-width: 400px;
                animation: slideUp 0.4s ease-out;
              }

              .loading-spinner {
                width: 50px;
                height: 50px;
                border: 4px solid #f3f3f3;
                border-top: 4px solid #DC143C;
                border-radius: 50%;
                animation: spin 1s linear infinite;
                margin: 0 auto 20px;
              }

              .member-loading-card h3 {
                color: #333;
                margin-bottom: 10px;
                font-size: 20px;
              }

              .member-loading-card p {
                color: #666;
                margin: 5px 0;
                font-size: 14px;
              }

              .loading-message {
                color: #DC143C !important;
                font-weight: bold;
                margin-top: 15px !important;
              }

              @keyframes fadeIn {
                from { opacity: 0; }
                to { opacity: 1; }
              }

              @keyframes slideUp {
                from {
                  transform: translateY(20px);
                  opacity: 0;
                }
                to {
                  transform: translateY(0);
                  opacity: 1;
                }
              }

              @keyframes spin {
                0% { transform: rotate(0deg); }
                100% { transform: rotate(360deg); }
              }
            `;
            document.head.appendChild(styles);
          }

          // 1.5秒後にローディング表示を削除してから送信
          setTimeout(() => {
            loadingOverlay.remove();
            window.submitForm();
          }, 1500);

          // 既存会員のため直接送信（ローディング表示後）
          return;
        }
      } catch (error) {
        // エラーがあっても通常のフローを続行
        console.error('Firebase access error:', error);
        alert('システムエラーが発生しました。配信停止・購入者チェックができませんでした。');
      }
    }

    // 次のステップへ
    if (currentStep < 4) {
      window.showStep(currentStep + 1);
    }
  };
  
  window.previousStep = function() {
    const currentStepEl = document.querySelector('.form-step.active');
    const currentStep = parseInt(currentStepEl.dataset.step);
    if (currentStep > 1) {
      window.showStep(currentStep - 1);
    }
  };
  
  window.submitForm = async function() {

    // フォームデータを収集
    const form = document.getElementById('step-form');
    const formData = new FormData(form);
    const data = {
      email: formData.get('email'),
      name: `${formData.get('lastName') || ''} ${formData.get('firstName') || ''}`.trim(),
      company: formData.get('company') || '',
      whitepaperId: whitepaperId,
      whitepaperTitle: wp.title,
      reportId: whitepaperId,
      reportTitle: wp.title,
      timestamp: serverTimestamp()
    };

    // Firestoreにデータを保存（メール送信をトリガー）
    try {
      const docRef = await addDoc(collection(db, 'downloads'), data);
    } catch (error) {
      console.error('Registration error:', error);

      // Firestoreのアクセスエラーの場合でも、詳細なエラーは表示しない
      if (error.code === 'permission-denied') {
        alert('アクセスが制限されています。管理者にお問い合わせください。');
      } else {
        alert('登録エラーが発生しました。時間をおいて再度お試しください。');
      }
      // エラーが発生してもダウンロードは続行しない
      return;
    }
    
    // 成功画面を表示
    document.querySelector('.form-container').innerHTML = `
      <div class="success-message">
        <div class="success-icon">✓</div>
        <h2>ダウンロード準備完了</h2>
        <p>ご登録ありがとうございました。</p>
        <p class="download-link">
          <a href="${window.location.origin}/pdf/${whitepaperId}.pdf" target="_blank" class="btn-primary">
            PDFをダウンロード
          </a>
        </p>
        <p style="margin-top: 20px;">
          <a href="/master/download">他の資料も見る</a>
        </p>
      </div>
    `;

    // ダウンロードリンクを新しいタブで開く（直接ダウンロードではなく）
    setTimeout(() => {
      window.open(`${window.location.origin}/pdf/${whitepaperId}.pdf`, '_blank');
    }, 1000);
  };
  
  return `
    <div class="download-page">
      <!-- ヘッダー -->
      <header class="download-header">
        <div class="header-inner">
          <h1 class="logo">
            <a href="/">
              <img src="/images/logo.svg" alt="反響成約マスター" />
            </a>
          </h1>
        </div>
      </header>
      
      <div class="download-main">
        <h1 class="page-title">資料ダウンロード</h1>
        
        <div class="download-content">
          <!-- 左側：ホワイトペーパー情報 -->
          <div class="whitepaper-info">
            <div class="whitepaper-card">
              <div class="whitepaper-image">
                <img src="${wp.image}" alt="${wp.title}" />
              </div>
            </div>
            <div class="whitepaper-details">
              <h3 class="whitepaper-title">${wp.title}</h3>
              <p class="whitepaper-meta">
                PDF資料
              </p>
            </div>
          </div>
          
          <!-- 右側：フォーム -->
          <div class="form-container">
            <!-- Web会員登録のメリット（最上部に配置） -->
            <div class="member-benefits-top">
              <h3>📊 Web会員登録で得られる2つの価値</h3>
              <ul class="benefit-list">
                <li>
                  <span class="check">✓</span>
                  <div>
                    <strong>${FORM_MESSAGES.memberBenefit}</strong>
                    <span class="value-note">（次回からワンクリック）</span>
                  </div>
                </li>
                <li>
                  <span class="check">✓</span>
                  <div>
                    <strong>週1回の最新事例メルマガ</strong>
                    <span class="value-note">（現場で使える実践ノウハウ）</span>
                  </div>
                </li>
              </ul>
              <p class="register-time">⏱ 60秒で登録完了・完全無料</p>
              <p style="font-size: 11px; color: #999; margin-top: 10px;">
                ※会員期間中のみダウンロード可。配信停止後は再取得不可
              </p>
            </div>
            
            <div class="form-header">
              <span class="step-indicator">ステップ 1/2</span>
              <div class="progress-container">
                <div class="progress-bar" style="width: 50%"></div>
              </div>
            </div>
            
            <form id="step-form" onsubmit="return false;">
              <!-- ステップ1: メールアドレス -->
              <div class="form-step active" data-step="1">
                <h2>メールアドレスをご入力ください</h2>
                <p class="step-description">
                  Web会員の方はご登録メールアドレスをご入力ください。<br>
                  登録がお済みでない方はメールアドレスと必要事項のご登録をお願いいたします。
                </p>
                
                <div class="form-group">
                  <label class="required">メールアドレス</label>
                  <input type="email" name="email" required placeholder="例：sample@company.jp" />
                  <div class="email-notice">
                    ※ メールアドレスはdocomo、au、softbankなどの携帯メール、icloud.comは登録できません。
                  </div>
                </div>
                
                <div class="continue-motivation">
                  <p>${FORM_MESSAGES.motivation}</p>
                  <p style="font-size: 14px; color: #666; margin-top: 5px;">${FORM_MESSAGES.newRelease}</p>
                </div>
                
                <button type="button" class="btn-primary" onclick="nextStep()">次へ</button>
                
                <p class="text-muted">
                  株式会社南勝は、当社が保有するお客様の個人情報を保護するため個人情報保護法を含め関係する法令・
                  ガイドラインなどを遵守します。
                </p>
                
                <p class="privacy-link">
                  <a href="/privacy.html" target="_blank">個人情報の取り扱いについて</a>
                </p>
              </div>
              
              <!-- ステップ2: 新規登録（姓・名） -->
              <div class="form-step" data-step="2">
                <h2>新規登録</h2>
                <p class="step-description">
                  入力されたメールアドレスのWeb会員登録はありませんでした。お手数ですが、下記の登録フォームにご記入ください。<br>
                  登録後はこのフォームにご記入いただく必要はありません。
                </p>
                
                <p class="login-option">
                  <a href="#" onclick="showStep(1); return false;">登録せずに、別のメールアドレスでログインする</a>
                </p>
                
                <div class="form-row">
                  <div class="form-group">
                    <label class="required">姓</label>
                    <input type="text" name="lastName" required placeholder="例：山田" />
                  </div>
                  <div class="form-group">
                    <label class="required">名</label>
                    <input type="text" name="firstName" required placeholder="例：太郎" />
                  </div>
                </div>
                
                <div class="continue-motivation">
                  <p>📝 あと1ステップで完了します</p>
                </div>
                
                <button type="button" class="btn-primary" onclick="nextStep()">次へ</button>
                <button type="button" class="btn-secondary" onclick="previousStep()">前へ</button>
              </div>
              
              <!-- ステップ3: 会社名 + 送信 -->
              <div class="form-step" data-step="3">
                <h2>新規登録</h2>

                <div class="form-group">
                  <label class="required">会社名</label>
                  <input type="text" name="company" required placeholder="会社名 + 住所（事業所名）で検索・絞り込み" />
                  <div id="company-suggestions" class="suggestions"></div>
                </div>

                <input type="hidden" name="newsletter" value="yes" />

                <p class="text-muted">
                  株式会社南勝は、当社が保有するお客様の個人情報を保護するため個人情報保護法を含め関係する法令・
                  ガイドラインなどを遵守します。
                </p>

                <p class="privacy-link">
                  <a href="/privacy.html" target="_blank">個人情報の取り扱いについて</a>
                </p>

                <button type="button" class="btn-primary" onclick="submitForm()">ダウンロード</button>
                <button type="button" class="btn-secondary" onclick="previousStep()">前へ</button>
              </div>
            </form>
            
          </div>
        </div>
      </div>
      
      <!-- フッター -->
      <footer class="download-footer">
        <div class="footer-inner">
          <div class="footer-logo">反響成約マスター</div>
          <nav class="footer-nav">
            <a href="/privacy.html">個人情報の取り扱いについて</a>
            <a href="/company.html">会社概要</a>
            <a href="/master/contact">お問い合わせ</a>
          </nav>
          <p class="footer-company">運営：株式会社南勝</p>
          <p class="copyright">Copyright © 2025 株式会社南勝. All Rights Reserved.</p>
        </div>
      </footer>
    </div>
  `;
}